module.exports = __webpack_public_path__ + "prod/1.42.2/img/select-icon-2.db5748d0.png";